import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal, viewChild, WritableSignal } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { PermissionsTreeComponent } from 'mbs-ui-shared@components/permissions-tree/permissions-tree.component';
import { AccountTypeEnum, Permissions } from 'mbs-ui-shared@models';
import { McpSettingsService } from 'mbs-ui-shared@services/mcp-settings.service';

export type ManualPermissionsModalData = {
  accountType: AccountTypeEnum;
  permissions: Permissions;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, ModalComponent, ModalFooterDirective, PermissionsTreeComponent],
  selector: 'mbs-manual-permissions-modal',
  standalone: true,
  templateUrl: './manual-permissions-modal.component.html'
})
export class ManualPermissionsModalComponent {
  protected readonly mcpSettings = inject(McpSettingsService);

  protected readonly baseModal = viewChild(ModalComponent);

  public readonly accountType: WritableSignal<AccountTypeEnum> = signal(null);
  public readonly permissions: WritableSignal<Permissions> = signal({} as Permissions);
  public readonly ready: WritableSignal<boolean> = signal(false);

  constructor() {
    this.mcpSettings.load();

    // ModalService assigns data only after open() returns, and a signal viewChild is unresolved until the view is checked
    afterNextRender(() => this.applyModalData());
  }

  public applyClickHandler(): void {
    this.baseModal().save(this.permissions());
  }

  public cancelClickHandler(): void {
    this.baseModal().close();
  }

  // Private section
  private applyModalData(): void {
    const data = this.baseModal()?.data as ManualPermissionsModalData;

    this.accountType.set(data?.accountType ?? null);
    this.permissions.set(data?.permissions ?? ({} as Permissions));
    this.ready.set(true);
  }
}
